export interface BuildAdditionalNotesInput {
  destinationNote?: string;
  userNotes?: string;
  card?: string;
  sourceUrl?: string;
}

export const buildAdditionalNotes = ({
  destinationNote,
  userNotes,
  card,
  sourceUrl,
}: BuildAdditionalNotesInput): string => {
  const noteSegments: string[] = [];

  if (destinationNote) {
    noteSegments.push(`ChosenDestination: '${destinationNote}'`);
  }

  if (userNotes) {
    noteSegments.push(`UserNotes: '${userNotes}'`);
  }

  if (card) {
    noteSegments.push(`Card: '${card}'`);
  }

  if (sourceUrl) {
    noteSegments.push(`SourceUrl: '${sourceUrl}'`);
  }

  return noteSegments.join(', ');
};
